export const GET_CASES_PENDING = '[CASES][GET] get Cases pending';
export const GET_CASES_SUCCESS = '[CASES][GET] get Cases success';
export const GET_CASES_FAILURE = '[CASES][GET] get Cases failure';
export const GET_CASE_DETAILS_PENDING = '[CASES][DETAIL] get case details pending';
export const GET_CASE_DETAILS_SUCCESS = '[CASES][DETAIL] get case details success';
export const GET_CASE_DETAILS_FAILURE = '[CASES][DETAIL] get case details failure';
export const GET_FIELD_PENDING = '[CASES][FIELD] get field pending';
export const GET_FIELD_SUCCESS = '[CASES][FIELD] get field success';
export const GET_FIELD_FAILURE = '[CASES][FIELD] get field failure';
export const GET_CASE_IDS_PENDING = '[CASES][GET] get Case Ids pending';
export const GET_CASE_IDS_SUCCESS = '[CASES][GET] get Case Ids success';
export const GET_CASE_IDS_FAILURE = '[CASES][GET] get Case Ids failure';
export const GET_CASES_MESSAGES_COUNTS_PENDING = '[CASES][GET] get cases messages count pending';
export const GET_CASES_MESSAGES_COUNTS_SUCCESS = '[CASES][GET] get cases messages count success';
export const GET_CASES_MESSAGES_COUNTS_FAILURE = '[CASES][GET] get cases messages count failure';
export const RESET_CASES_MESSAGES_COUNTS = '[CASES][GET] reset counts';
export const LOADING_CASES = '[LOADING][CASES] set loading cases';

export const GET_APPLICANT_CASE_DETAILS_SUCCESS = '[CASES][DETAIL] get applicant case details success';

export const FETCH_TASKS_SUCCESS = '[FETCH][TASKS] success fetch tasks';
export const LOADING_TASKS = '[LOADING][TASKS] set loading tasks';

export const FETCH_MESSAGES_COUNT_SUCCESS = '[FETCH][MESSAGES] success fetch messages count';
export const LOADING_MESSAGES_COUNT = '[LOADING][MESSAGES] set loading messages count';

export const FETCH_CONTACTS_SUCCESS = '[FETCH][CONTACTS] success fetch contacts';
export const LOADING_CONTACTS = '[LOADING][CONTACTS] set loading contacts';

// modal
export const SHOW_FILTER_MODAL = '[CASES][FILTERS] toggle Modal';
export const APPLY_CASES_FILTERS = '[CASES][FILTERS] apply filters';
export const APPLY_CASES_FILTERS_SUCCESS = '[CASES][FILTERS] apply filters success';
export const APPLY_CASES_FILTERS_FAILURE = '[CASES][FILTERS] apply filters failure';
export const GO_TO_DETAILS = '[CASES][LINK] redirect to case details';
export const GET_FILTERS_SUCCESS = '[CASES][FILTERS] get case filters';
export const STORE_CASE_DETAILS = '[CASES][DETAIL] store case details.';
export const STORE_CASE_MANAGER_ID = '[CASES][DETAIL] store case manager id.';
export const STORE_CASE_MESSAGES_COUNT = '[CASES][DETAIL] store case messages count';
export const GET_IMMIGRATION_PATHWAY_SUCCESS = '[CASES][IMMIGRATION] get the immigration list success';
export const STORE_CASES_FILTERS = '[CASES][FILTERS] store cases filters';

export const SHOW_NOTIFICATION_SUCCESS = '[CASES][SHOW] show notification success';
export const HIDE_NOTIFICATION_SUCCESS = '[CASES][HIDE] hide notification success';
export const RESET_CASE_MANAGER_ID = '[CASES][DETAIL] clear case manager id';
export const GET_CASE_PHASES_SUCCESS = '[CASES][DETAIL] get case phases';
export const GET_CASE_LM_SUCCESS = '[CASES][DETAIL] get line managers';
export const GET_CASE_LM_FILTER_SUCCESS = '[CASES][DETAIL] get line managers filters';
export const GET_CASE_CLIENT_LM_ERROR = '[CASES][DETAIL] get corporate line managers errors';
export const GET_CASE_LM_ERROR = '[CASES][DETAIL] get line managers errors';
export const GET_CASE_CLIENT_LM_SUCCESS = '[CASES][DETAIL] get client line managers';
export const SAVE_CASE_CLIENT_LM_SUCCESS = '[CASES][DETAIL] save client line managers';
export const SAVE_CASE_CLIENT_NEW_LM_SUCCESS = '[CASES][DETAIL] save new line managers';
export const SET_CASE_LM_COUNT = '[CASES][DETAIL] set line managers count';

export const LABEL_ALL_CASES = 'All Cases';
export const LABEL_OPEN_CASES = 'Open Cases';
export const LABEL_CLOSED_CASES = 'Closed Cases';
export const LABEL_ON_TRACK_CASES = 'On Track';
export const LABEL_OFF_TRACK_CASES = 'Off Track';
export const LABEL_URGENT_CASES = 'Urgent';

export const RESET_CASE_DETAILS = '[CASES][DETAIL] reset';
export const UPDATE_ADDITIONAL_INFO_STATUS = '[CASES][DETAIL] update additional information section existance';
export const UPDATE_ADDITIONAL_INFO_DATA = '[CASES][DETAIL] update additional information data';
export const UPDATE_MAIN_CASE_INFO_DATA = '[CASES][DETAIL] update main case detail data';
export const SET_NEW_ADDITIONAL_INFO_RECORD_ID = '[CASES][DETAIL] set additional information record id';
export const SET_BPF_STATUS_INFO = '[CASES][DETAIL] set bpf status info';

export const CASES_LANDING_TAB = [
  LABEL_ALL_CASES,
  LABEL_OPEN_CASES,
  LABEL_CLOSED_CASES,
  /*LABEL_ON_TRACK_CASES,
  LABEL_OFF_TRACK_CASES,
  LABEL_URGENT_CASES,*/
];
